import React from "react";
import "./styles.css";
import Blog from "../../blog";
import Footer from "../../UI/footer";
import ResourcesIntro from "../../resources-intro";
import YoutubeChannel from "../../youtube-channel";
import Podcast from "../../podcast";

function Resources() {
  return (
    <div className="resources">
      <ResourcesIntro />
      <Blog title={"Visita nuestro blog"} />
      <YoutubeChannel />
      <Podcast />
      <Footer />
    </div>
  );
}

export default Resources;
